import type {
  DefaultError,
  UseMutationOptions,
} from '@tanstack/react-query'
import type {
  PostGoogleLoginRequest,
  PostGoogleLoginResponse,
} from '~/lib/services/api/user'

import {
  useMutation,
} from '@tanstack/react-query'
import {
  postGoogleLogin,
} from '~/lib/services/api/user'

function useGoogleLogin() {
  const mutationFn = async (payload: PostGoogleLoginRequest) => {
    const response = await postGoogleLogin(payload)
    return response.data
  }

  const options: UseMutationOptions<
    PostGoogleLoginResponse,
    DefaultError,
    PostGoogleLoginRequest,
    unknown
  > = {
    mutationFn,
  }

  return useMutation(options)
}

export default useGoogleLogin
